<template>
    <v-row id="facility__facility-basics">
        <v-col cols="12">
            <h2 class="mt-4">Basic Information</h2>
        </v-col>
        <v-col cols="4">
          <v-switch
              data-testid="facility-basic-pms-switch"
              class="facility-basic-pms-switch"
              :label="currentFacility.pms_enabled ? 'Property Management Enabled' : 'Property Management Disabled'"
              v-model="currentFacility.pms_enabled"
          />
        </v-col>
        <v-col cols="8">
          <p class="subheading pt-3">
              <label class="font-weight-bold">PMS Type: </label>
              <span>{{ currentFacility.pms.length ? currentFacility.pms[0].name : 'Not configured' }}</span>
              <template v-if="!currentFacility.pms.length">
                <br>
                <span class="text-caption">* Contact dev team to configure PMS after creating a new facility.</span>
              </template>
          </p>
        </v-col>
        <v-col cols="12" sm="4">
            <app-input
                data-testid="facility-basic-location-code-input"
                class="facility-basic-location-code-input"
                v-model.trim="currentFacility.location_code"
                :type="'text'"
                label="Location Code"
                hint="Property Management enabled example: L010; Property Management disabled example: X010"
                :rules="{ required: true }"
                :useValidation="true"
            />
        </v-col>
        <v-col cols="12" sm="4">
            <v-select
                data-testid="facility-basic-district-select"
                class="facility-basic-district-select"
                filled
                v-model.trim="currentFacility.district"
                :items="districts"
                label="District"
                clearable
            />
        </v-col>
        <v-col cols="12" sm="4">
            <app-input
                data-testid="facility-basic-name-input"
                class="facility-basic-name-input"
                :type="'text'"
                v-model.trim="currentFacility.name"
                label="Facility Name"
                :rules="{ required: true }"
                :useValidation="true"
            />
        </v-col>
        <v-col cols="12" sm="4">
            <app-input
                data-testid="facility-basic-legal-name-input"
                class="facility-basic-legal-name-input"
                :type="'text'"
                v-model.trim="currentFacility.legal_name"
                label="Facility Legal Name"
            />
        </v-col>
    </v-row>
</template>

<script>
import AppInput from "@/components/global/AppInput";
import { facilityDistricts } from "@/helpers/facility/facility-districts-list";

export default {
  components: {
    AppInput
  },

  data() {
    return {
      districts: facilityDistricts
    };
  },

  computed: {
    currentFacility: {
      get() {
        return this.$store.state.facility.currentFacility;
      },
      set(newValue) {
        this.$store.commit("setCurrentFacilityData", newValue);
      }
    }
  }
};
</script>
